import { render, staticRenderFns } from "./EndpointDetail.vue?vue&type=template&id=4a565a40&"
import script from "./EndpointDetail.vue?vue&type=script&lang=js&"
export * from "./EndpointDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports